import React from "react";
import { useInstallPrompt } from "@/hooks/useInstallPrompt";
import { Button } from "@/components/ui/button";
import { Card, CardContent } from "@/components/ui/card";
import { Download, X } from "lucide-react";

export function InstallPrompt() {
  const { isInstallable, shouldShowBanner, showInstallPrompt, dismissPrompt } =
    useInstallPrompt();

  // Don't show if not installable or banner should be hidden
  if (!isInstallable || !shouldShowBanner) {
    return null;
  }

  const handleInstall = async () => {
    const installed = await showInstallPrompt();
    if (!installed) {
      // User dismissed or installation failed
      console.log("Installation cancelled or failed");
    }
  };

  const handleDismiss = () => {
    dismissPrompt();
  };

  return (
    <div className="fixed bottom-4 left-4 right-4 z-50 md:left-auto md:right-4 md:max-w-md">
      <Card className="shadow-lg border-2">
        <CardContent className="p-4">
          <div className="flex items-start gap-3">
            {/* Icon */}
            <div className="flex-shrink-0 p-2 bg-primary/10 rounded-lg">
              <Download className="h-6 w-6 text-primary" />
            </div>

            {/* Content */}
            <div className="flex-1 min-w-0">
              <h3 className="text-sm font-semibold text-foreground mb-1">
                Install RaceFlow App
              </h3>
              <p className="text-xs text-muted-foreground mb-3">
                Install our app for quick access, offline support, and push
                notifications.
              </p>

              {/* Actions */}
              <div className="flex gap-2">
                <Button onClick={handleInstall} size="sm" className="flex-1">
                  <Download className="mr-2 h-3 w-3" />
                  Install
                </Button>
                <Button onClick={handleDismiss} size="sm" variant="outline">
                  Later
                </Button>
              </div>
            </div>

            {/* Close Button */}
            <button
              onClick={handleDismiss}
              className="flex-shrink-0 p-1 hover:bg-muted rounded transition-colors"
              aria-label="Dismiss"
            >
              <X className="h-4 w-4 text-muted-foreground" />
            </button>
          </div>
        </CardContent>
      </Card>
    </div>
  );
}
